/**
 * Két dátum közötti különbséget adja vissza milliszekundumban.
 * @param {Date | string} param1 - Az egyik dátum. Ebből lesz kivonva a másik.
 * @param {Date | string} param2 - A másik dátum. Ezt vonjuk ki az elsőből.
 * @returns {number} A különbség milliszekundumban.
 */
module.exports.getDiffMs = function getDiffMs (param1, param2) {
  const date1 = new Date(param1)
  const date2 = new Date(param2)

  const diffMs = date1.getTime() - date2.getTime()

  return diffMs
}
